// Distractor crop authoring for Remote DC.
import {
  ConvertCropsToDistractorsRequest,
  CreateDistractorCropsRequest,
  CreateDistractorCropsResponse,
  DeleteDistractorCropsRequest,
  DeleteDistractorCropsResponse,
  DistractorClass,
  DistractorClassCountsResponse,
  DistractorCropsListResponse,
  RelabelDistractorCropsRequest,
  RelabelDistractorCropsResponse,
} from '../../types/distractors';
import { forgeRequest } from '../forgeRequest';
import { FORGE_REMOTE_DATA_COLLECTION_API_URL } from './endpoints';

export async function createDistractorCrops(
  token: string,
  request: CreateDistractorCropsRequest
): Promise<CreateDistractorCropsResponse> {
  return forgeRequest<CreateDistractorCropsResponse>(
    token,
    `${FORGE_REMOTE_DATA_COLLECTION_API_URL}/distractor-crops`,
    'Error creating distractor crops',
    { method: 'POST', body: request }
  );
}

export async function listDistractorCrops(
  token: string,
  params: {
    chainId: number;
    distractorClass?: DistractorClass;
    imageId?: number;
    limit?: number;
    offset?: number;
  },
  options?: { signal?: AbortSignal }
): Promise<DistractorCropsListResponse> {
  const query = new URLSearchParams({ chain_id: String(params.chainId) });
  if (params.distractorClass) query.set('distractor_class', params.distractorClass);
  if (params.imageId != null) query.set('image_id', String(params.imageId));
  if (params.limit != null) query.set('limit', String(params.limit));
  if (params.offset != null) query.set('offset', String(params.offset));
  return forgeRequest<DistractorCropsListResponse>(
    token,
    `${FORGE_REMOTE_DATA_COLLECTION_API_URL}/distractor-crops?${query.toString()}`,
    'Error fetching distractor crops',
    { signal: options?.signal }
  );
}

export async function fetchDistractorClassCounts(
  token: string,
  chainId: number,
  options?: { signal?: AbortSignal }
): Promise<DistractorClassCountsResponse> {
  return forgeRequest<DistractorClassCountsResponse>(
    token,
    `${FORGE_REMOTE_DATA_COLLECTION_API_URL}/distractor-crops/class-counts?chain_id=${chainId}`,
    'Error fetching distractor class counts',
    { signal: options?.signal }
  );
}

export async function relabelDistractorCrops(
  token: string,
  request: RelabelDistractorCropsRequest
): Promise<RelabelDistractorCropsResponse> {
  return forgeRequest<RelabelDistractorCropsResponse>(
    token,
    `${FORGE_REMOTE_DATA_COLLECTION_API_URL}/distractor-crops/relabel`,
    'Error relabeling distractor crops',
    { method: 'POST', body: request }
  );
}

export async function convertCropsToDistractors(
  token: string,
  request: ConvertCropsToDistractorsRequest
): Promise<RelabelDistractorCropsResponse> {
  return forgeRequest<RelabelDistractorCropsResponse>(
    token,
    `${FORGE_REMOTE_DATA_COLLECTION_API_URL}/distractor-crops/convert`,
    'Error marking crops as distractors',
    { method: 'POST', body: request }
  );
}

export async function deleteDistractorCrops(
  token: string,
  request: DeleteDistractorCropsRequest
): Promise<DeleteDistractorCropsResponse> {
  return forgeRequest<DeleteDistractorCropsResponse>(
    token,
    `${FORGE_REMOTE_DATA_COLLECTION_API_URL}/distractor-crops/delete`,
    'Error deleting distractor crops',
    { method: 'POST', body: request }
  );
}
